import { useCallback, useMemo } from "react";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useGetAdvisors(currentUserId) {
  const queryFactory = useCallback(() => {
    const query = `
    query getAdvisors($id: ID!) {
      advisors {
        edges {
          node {
            uuid
            name
          }
        }
      }
      advisor(id: $id) {
        name
        numOfTasks
      }
    }`;

    const resolver = ({ data: { advisors, advisor } }) => {
      return [
        advisors.edges
          .map(({ node }) => {
            return { ...node, id: node.uuid };
          })
          .filter(({ id }) => {
            return id !== currentUserId;
          }),
        advisor,
      ];
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, [currentUserId]);

  const {
    loading,
    data: [advisors = [], currentUser = {}] = [],
    error,
  } = useQuery(
    queryFactory,
    useMemo(() => {
      return {
        variables: { id: toGlobalId("Advisor", currentUserId) },
      };
    }, [currentUserId])
  );

  return {
    loading: loading,
    advisors: advisors,
    currentUser: currentUser,
    error: error
      ? error[0]?.message ||
        "Failed to load the other available users , please retry or contact support for assistance"
      : "",
  };
}

export default useGetAdvisors;
